import DownloadInAppQRCode from './DownloadInAppQRCode';

export default DownloadInAppQRCode;
